import { CrctInv } from 'src/app/_models/inv';
import { TipMvtcGrupoCrctInvAcao } from 'src/app/_models/grCrctInv/grCrctInv';

export class CarteiraMvtcAddDataParm{
  public cdGrCrctInvAcao: number;
  public crctInv: CrctInv;
  public tipMvtcGrCrctInvAcao: TipMvtcGrupoCrctInvAcao;
}
